var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#F0F3F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4691 13.3021C30.2754 13.1087 30.0128 13 29.739 13C29.4653 13 29.2027 13.1087 29.009 13.3021L16.3461 25.9627C16.2167 26.0923 16.124 26.2539 16.0775 26.431L14.7001 31.7063C14.6546 31.8806 14.6555 32.0638 14.7027 32.2377C14.7499 32.4115 14.8418 32.57 14.9692 32.6974C15.0966 32.8248 15.2551 32.9167 15.429 32.9639C15.6029 33.0111 15.7861 33.012 15.9604 32.9666L21.2333 31.5892C21.4111 31.5426 21.5732 31.4494 21.703 31.3193L34.3645 18.6586C34.558 18.4649 34.6666 18.2024 34.6666 17.9286C34.6666 17.6549 34.558 17.3923 34.3645 17.1986L30.4691 13.3021ZM18.0046 27.2258L29.739 15.4935L32.173 17.9273L20.4399 29.6609L17.1437 30.5218L18.0046 27.2258Z",
    fill: "#004529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7121 35C14.4348 35 14.1689 35.1054 13.9728 35.2929C13.7768 35.4804 13.6666 35.7348 13.6666 36C13.6666 36.2652 13.7768 36.5196 13.9728 36.7071C14.1689 36.8946 14.4348 37 14.7121 37H35.6212C35.8984 37 36.1644 36.8946 36.3604 36.7071C36.5565 36.5196 36.6666 36.2652 36.6666 36C36.6666 35.7348 36.5565 35.4804 36.3604 35.2929C36.1644 35.1054 35.8984 35 35.6212 35H14.7121Z",
    fill: "#004529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPhoto);
export default __webpack_public_path__ + "static/media/editPhoto.d108eb24e76356a33a8b70b9946e6d86.svg";
export { ForwardRef as ReactComponent };